import axiosBase from "@/api/axiosBase";

const state = {
}

const getters = {

}

const actions = {
    //运行模型
    setSceneRun({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/ctrl/run',
                data:{
                    "model_id": data.sceneId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取模型状态
    getSceneStatus({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/ctrl/status',
                data:{
                    "model_ids": data.sceneIds
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取模型运行进度
    getSceneProgress({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/ctrl/progress',
                data:{
                    "model_ids": data.sceneIds
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //终止模型
    stopSceneRun({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/ctrl/kill',
                data:{
                    "model_id": data.sceneId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //清除模型结果
    clearSceneResult({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/base/clearResult/' + data.sceneId,
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取实时运行指标
    getRunningPolls({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/running/vars',
                data:{
                    "model_id": data.sceneId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取实时运行时间序列
    getRunningTimeSeries({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/running/tseries',
                data:{
                    "model_id": data.sceneId,
                    "prev_datetime": data.prev_datetime,
                    "subids": data.fIds,
                    "vars": data.vars
                }
            }).then(res=>{
                if(res.data.code != 200 ){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取实时运行空间分布
    getRunningSnapshot({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/running/snapshot',
                data:{
                    "model_id": data.sceneId,
                    "vars": data.vars
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
}

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}